
export const LOGIN_SUCCESS="LOGIN_SUCCESS"
export const LOGIN_FAILURE="LOGIN_FAILURE"
export const ADMIN_LOGIN_SUCCESS="ADMIN_LOGIN_SUCCESS"
export const ADMIN_LOGIN_FAILURE="ADMIN_LOGIN_FAILURE"